(ns iris.screens.events
  (:require
   [re-frame.core :as re-frame]
   [ajax.core :as ajax]
   [cljs.core.async :refer [go go-loop <! chan take!]]
   [iris.events :as events]
   [iris.error.events :as error-events]
   [iris.hench :as hench]
   [iris.indexeddb :as idb]
   [clojure.string :as string]
   [iris.worker-pool :as worker-pool]
   ))


(re-frame/reg-event-db
 ::set-screen-prop
 (fn [db [_ prop val]]
   (assoc-in db [:screens :form-data prop] val)))


(re-frame/reg-event-db
 ::add-pattern
 (fn [db [_ val]]
   (update-in db [:screens :form-data :patterns] conj val)))


(re-frame/reg-event-db
 ::reset-form-data
 (fn [db [_ data]]
   (let [defaults {:ts (.now js/Date)
                   :actions []
                   :target_level 0
                   :scopes_input ".ALL"
                   :kind "content"
                   :patterns [{:id (.now js/Date)
                               :kind "word"
                               :pattern nil
                               :target_fields ["title" "body" "signed"]
                               :case_sensitive false
                               :preserve_case false
                               :ignore_inserts false
                               :similar_chars false}]
                   :disable_in nil
                   :disable-in-number nil
                   :disable-in-unit "d"
                   :priority 0
                   :enabled true
                   :notes ""
                   :submitted false}
         form-data (if (some? data) (merge defaults data) defaults)]
     (assoc-in db [:screens :form-data] form-data))))


(re-frame/reg-event-db
 ::delete-pattern
 (fn [db [_ id]]
   (let [filtered (filterv (fn [item] (not= (:id item) id)) (get-in db [:screens :form-data :patterns]))]
     (assoc-in db [:screens :form-data :patterns] filtered))))


(re-frame/reg-event-db
 ::set-pattern-prop
 (fn [db [_ id param value]]
   (let [updated (mapv (fn [item]
                        (if (= (:id item) id)
                          (assoc item param value)
                          item))
                      (get-in db [:screens :form-data :patterns]))]
     (assoc-in db [:screens :form-data :patterns] updated))))


(re-frame/reg-event-db
 ::add-action
 (fn [db [_ val]]
   (update-in db [:screens :form-data :actions] conj val)))


(re-frame/reg-event-db
 ::delete-action
 (fn [db [_ action]]
   (let [filtered (filterv (fn [item] (not= (:action item) action)) (get-in db [:screens :form-data :actions]))]
     (assoc-in db [:screens :form-data :actions] filtered))))


(re-frame/reg-event-db
 ::set-action-prop
 (fn [db [_ action param value]]
   (let [updated (mapv (fn [item]
                         (if (= (:action item) action)
                           (assoc item param value)
                           item))
                       (get-in db [:screens :form-data :actions]))]
     (assoc-in db [:screens :form-data :actions] updated))))


(re-frame/reg-event-db
 ::http-complete
 (fn [db [_ data]]
   (assoc db :loading false)))


(re-frame/reg-event-db
 ::http-create-screen-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])
   (re-frame/dispatch [::events/navigate :screens])
   (-> db
       (assoc-in [:screens :form-data :submitted] false)
      ;;  (assoc-in
      ;;   ;; [:screens :message]
      ;;   [:message]
      ;;   (or (get-in data [:result :message]) (get-in data [:error :message])))
       )))


(re-frame/reg-event-db
 ::http-create-screen-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   (-> db
       (assoc-in [:screens :form-data :submitted] false)
      ;;  (assoc-in [:screens :message] "API connection failure!")
      ;;  (assoc-in [:message] "API connection failure!")
       )))


(re-frame/reg-event-db
 ::set-screen-submitted
 (fn [db [_ data]]
   (assoc-in db [:screens :form-data :submitted] data)))


(re-frame/reg-event-fx
 ::screen-create
 (fn [e [_ data]]
   (re-frame/dispatch [::reset-form-data])
   (re-frame/dispatch [::set-screen-submitted true])
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Screen.Create"
                     :params {:options {:debug false}
                              :data data}}
                    [::http-create-screen-success]
                    [::http-create-screen-failure])))


(re-frame/reg-event-db
 ::set-screen-list-data
 (fn [db [_ data]]
   (let [result-data (get-in data [:result :data])
         result-meta (get-in data [:result :meta])]
     (-> db
         (assoc-in [:screens :data] result-data)
         (assoc-in [:screens :meta] result-meta)))))


;; (re-frame/reg-event-db
;;  ::http-get-screen-list-success
;;  (fn [db [_ data]]

;;    (re-frame/dispatch [::set-screen-list-data data])
;;    (re-frame/dispatch [::http-complete])

;;   ;;  perhaps this part below could be moved into its own function
;;    (let [result-data (get-in data [:result :data])
;;          eids (hench/get-distinct-scopes result-data)
;;          eids-count (count eids)
;;          c (chan)] ;; not sure if c chan should be global or not

;;      (when (not-empty eids)
;;        (hench/eid-to-raid-set-cache eids c)
;;        (go-loop [l eids-count]
;;          (let [eid-raid (<! c)
;;                eid (:eid eid-raid)
;;                raid (:raid eid-raid)]
;;            (idb/add-raid eid raid))
;;          (if (> l 1)
;;            (recur (dec l))
;;            (loop [result-data (get-in data [:result :data])
;;                   raidized-data []]
;;              (let [d (first result-data)
;;                    rest-data (rest result-data)
;;                    new-raidized-data (conj raidized-data (conj d [:scopes-display-raidized (<! (hench/raidize-cached (:scopes d) (string/replace (:scopes_display d) "screens" "screening")))]))]
;;                (if (not-empty rest-data)
;;                  (recur rest-data new-raidized-data)
;;                  (let [new-data (assoc-in data [:result :data] new-raidized-data)]
;;                    (re-frame/dispatch [::set-screen-list-data new-data])))))))))
;;    db))


(re-frame/reg-event-db
 ::http-get-screen-list-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ data]]

   (re-frame/dispatch [::set-screen-list-data data])
   (re-frame/dispatch [::http-complete])

  ;;  first raidize distinct eids and store in cache/indexeddb
  ;;  then use raids from cache to raidize display scopes
  ;;  could/should store results of raidize-eids to :posts :fb-data :eid-raid?
  ;;  worker raidize eids already gives eid-raid pairs - it could be used to raidize scopes display
  ;;  raidized-cached is unnecessarily calling indexeddb, better idea is to raidize and then pass raidized eids to function that raidizes scopes
  ;;  go version works but since raidize-scopes-display is called 50 times (or howeever many scopes to raidize there are) function will run create 50 go blocks
  ;; turned off raiding eids through worker and firebase
  ;;  (when-let [result-data (get-in data [:result :data])]
  ;;    (when-let [eids (not-empty (hench/get-distinct-scopes result-data))]
  ;;      (take! (worker-pool/do! {:handler :raidize-eids, :arguments {:data eids}})
  ;;             (fn [raidized-result-data]
  ;;               ;; (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-result-data [:result])])
  ;;               (loop [result-data result-data
  ;;                      raidized-data []]
  ;;                 (let [d (first result-data)
  ;;                       rest-data (rest result-data)
  ;;                       new-raidized-data (conj raidized-data
  ;;                                               (conj d [:scopes-display-raidized
  ;;                                                        (hench/raidize-scopes-display
  ;;                                                         (:scopes d)
  ;;                                                         (string/replace (:scopes_display d) "screens" "screening")
  ;;                                                         {:eids-raids (:result raidized-result-data)})]))]
  ;;                   ;; (println "eids-len-raids::" (hench/eids-len-raids (:scopes d) 3))
  ;;                   ;; (let [eids-raids (hench/eids-len-raids (:scopes d) 3)
  ;;                   ;;       display (hench/raidize-scopes-display
  ;;                   ;;                (:scopes d)
  ;;                   ;;                (string/replace (:scopes_display d) "screens" "screening")
  ;;                   ;;                {:eids-raids eids-raids})]
  ;;                   ;;   (println "display" display)
  ;;                   ;;   )

  ;;                   (if (not-empty rest-data)
  ;;                     (recur rest-data new-raidized-data)
  ;;                     (let [new-data (assoc-in data [:result :data] new-raidized-data)]
  ;;                       (re-frame/dispatch [::set-screen-list-data new-data])))))))))
   db))


(re-frame/reg-event-db
 ::http-get-screen-list-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;  (-> db
   ;;     ;;  (assoc-in [:screens :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


 (re-frame/reg-event-fx
  ::http-get-screen-list
  (fn [e [_ query-params]]
    (events/post-rpc {:jsonrpc "2.0"
               :id 0
               :method "Screen.List"
               :params {:options {:debug false}
                        :data (merge {:bookmark ""
                                      ;; :limit (if-not (zero? (int (:n query-params))) (int (:n query-params)) 50)
                                      :limit (if-not (zero? (int (:limit query-params))) (int (:limit query-params)) 50)
                                      :page (if-not (zero? (int (:page query-params))) (int (:page query-params)) 1)}
                                     (when-let [order (:order query-params)]
                                       {:order order})
                                     (when-let [scope (:scope query-params)]
                                       {:scope scope}))}}
              [::http-get-screen-list-success]
              [::http-get-screen-list-failure])))


;; enable

(re-frame/reg-event-db
 ::http-enable-screen-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])
   ;;  (-> db
   ;;      (assoc-in
   ;;       ;; [:screens :message]
   ;;       [:message]
   ;;       (or (get-in data [:result :message]) (get-in data [:error :message]))))
   db))


(re-frame/reg-event-db
 ::http-enable-screen-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;  (-> db
   ;;     ;;  (assoc-in [:screen :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::http-enable-screen
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Screen.Enable"
              :params {:options {:debug false}
                       :data ruid}}
             [::http-enable-screen-success]
             [::http-enable-screen-failure])))


(re-frame/reg-event-fx
 ::http-disable-screen
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Screen.Disable"
              :params {:options {:debug false}
                       :data ruid}}
             [::http-enable-screen-success]
             [::http-enable-screen-failure])))


(re-frame/reg-event-db
 ::set-screen-data
 (fn [db [_ data]]
   (-> db
       (assoc-in [:screens :form-data] (get-in data [:result :data]))
      ;;  TODO: check on this, took out message because it was resulting in message nil
       ;;  (assoc-in
      ;;   ;; [:screens :message]
      ;;   [:message]
      ;;   (get-in data [:error :message]))
       )))


;; (re-frame/reg-event-db
;;  ::http-get-screen-success
;;  (fn [db [_ data]]
;;    (re-frame/dispatch [::http-complete])
;;    (cond (get-in data [:result :data])
;;          (go
;;            (let [result-data (get-in data [:result :data])
;;                  eids (hench/get-distinct-scopes (conj [] result-data))
;;                  eid-raid (<! (worker-pool/do! {:handler :raidize-eids, :arguments {:data eids}}))
;;                  raidized-result-data (conj result-data [:scopes-input-raidized (<! (hench/raidize-cached (:scopes result-data) (:scopes_input result-data)))])
;;                  new-data (assoc-in data [:result :data] raidized-result-data)]

;;              (println "new-datanew-data"new-data)
;;              (re-frame/dispatch [::set-screen-data new-data])))
;;          (get-in data [:error :message])
;;          (re-frame/dispatch [::error-events/set-error {:title "Error: Screening rule not found!"
;;                                                        :message (get-in data [:error :message])
;;                                                        :a-href "/screening"
;;                                                        :a-txt "Return to Screening"}]))
;;    db))

(re-frame/reg-event-db
 ::http-get-screen-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])
   (cond (get-in data [:result :data])
        ;;  turned off raidizing eids through worker and firebase
        ;;  (when-let [result-data (get-in data [:result :data])]
        ;;    (if-let [eids (not-empty (hench/get-distinct-scopes (conj [] result-data)))]
        ;;      (take! (worker-pool/do! {:handler :raidize-eids, :arguments {:data eids}})
        ;;             (fn [raidized-eids]
        ;;               (let [scopes-input-raidized (hench/raidize-scopes-display
        ;;                                            (:scopes result-data)
        ;;                                            (:scopes_input result-data)
        ;;                                            {:eids-raids (:result raidized-eids)})
        ;;                     new-data (assoc-in data [:result :data :scopes-input-raidized] scopes-input-raidized)]
        ;;                 (re-frame/dispatch [::set-screen-data new-data]))))
        ;;     ;;  set data for non-raidazable eids such as ip
        ;;      (re-frame/dispatch [::set-screen-data data])))
         (re-frame/dispatch [::set-screen-data data])
         (get-in data [:error :message])
         (re-frame/dispatch [::error-events/set-error {:title "Error: Screening rule not found!"
                                                       :message (get-in data [:error :message])
                                                       :a-href "/screening"
                                                       :a-txt "Return to Screening"}]))
   db))


(re-frame/reg-event-db
 ::http-get-screen-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;this will not work - this gets triggered on http fail - not not being able to pull record, we still get valid response
   ;;  (-> db
   ;;     ;;  (assoc-in [:screens :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::http-get-screen
 (fn [e [_ id]]
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Screen.Get"
              :params {:options {:debug false}
                       :data (str "?" id)}}
             [::http-get-screen-success]
             [::http-get-screen-failure])))


(re-frame/reg-event-fx
 ::http-search-screen-list
 (fn [e [_ query-params]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Screen.Search"
                     :params {:options {:debug false}
                              :data (merge {:q (:q query-params)
                                            ;; :limit (if-not (zero? (int (:n query-params))) (int (:n query-params)) 50)
                                            :limit (if-not (zero? (int (:limit query-params))) (int (:limit query-params)) 50)
                                            :page (if-not (zero? (int (:page query-params))) (int (:page query-params)) 1)})}}
                    [::http-get-screen-list-success]
                    [::http-get-screen-list-failure])))


(re-frame/reg-event-db
 ::http-update-screen-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])
   (re-frame/dispatch [::events/navigate :screens])
   (-> db
       (assoc-in [:screens :form-data :submitted] false)
       ;;  (assoc-in
       ;;   ;; [:screens :message]
       ;;   [:message]
       ;;   (or (get-in data [:result :message]) (get-in data [:error :message])))
       )))


(re-frame/reg-event-db
 ::http-update-screen-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   (-> db
       (assoc-in [:screens :form-data :submitted] false)
       ;;  (assoc-in [:screens :message] "API connection failure!")
       ;;  (assoc-in [:message] "API connection failure!")
       )))


(re-frame/reg-event-fx
 ::screen-update
 (fn [e [_ data]]
   (re-frame/dispatch [::reset-form-data]) ;; is it needed for update?
   (re-frame/dispatch [::set-screen-submitted true]) ;; is it needed for update?
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Screen.Update"
              :params {:options {:debug false}
                       :data data}}
             [::http-update-screen-success]
             [::http-update-screen-failure])))


(re-frame/reg-event-db
 ::http-screen-delete-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])
   (when-let [message (get-in data [:result :message])]
     (let [ruid (last (re-find #"deleted:\s(.*)$" message))
           db-screens-data (get-in db [:screens :data])
           n-db-screens-data (filter #(not= ruid (:ruid %)) db-screens-data)]
       (assoc-in db [:screens :data] n-db-screens-data)
       (-> db
           (assoc-in [:screens :data] n-db-screens-data)
          ;;  (assoc-in
          ;;   ;; [:screens :message]
          ;;   [:message]
          ;;   (or (get-in data [:result :message]) (get-in data [:error :message])))
           )))))


(re-frame/reg-event-db
 ::http-screen-delete-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;  (-> db
   ;;     ;;  (assoc-in [:screens :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::screen-delete
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Screen.Delete"
              :params {:options {:debug false}
                       :data ruid}}
             [::http-screen-delete-success]
             [::http-screen-delete-failure])))



;; edit-enable

(re-frame/reg-event-db
 ::http-edit-enable-screen-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])
   (-> db
       (assoc-in [:screens :form-data :enabled] (get-in data [:result :data :enabled]))
       (assoc-in [:screens :form-data :iso_disable_on] (get-in data [:result :data :iso_disable_on]))
       (assoc-in [:screens :form-data :disable_in] (get-in data [:result :data :disable_in]))
      ;;  (assoc-in
      ;;   ;; [:screens :message]
      ;;   [:message]
      ;;   (or (get-in data [:result :message]) (get-in data [:error :message])))
       )))


(re-frame/reg-event-db
 ::http-edit-enable-screen-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;  (-> db
   ;;     ;;  (assoc-in [:screens :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::http-edit-enable-screen
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Screen.Enable"
              :params {:options {:debug false}
                       :data ruid}}
             [::http-edit-enable-screen-success]
             [::http-edit-enable-screen-failure])))


(re-frame/reg-event-fx
 ::http-edit-disable-screen
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Screen.Disable"
              :params {:options {:debug false}
                       :data ruid}}
             [::http-edit-enable-screen-success]
             [::http-edit-enable-screen-failure])))